<mat-tab-group>
  <mat-tab>
    <ng-template matTabLabel>
      <span i18n>Edit statuses</span>
    </ng-template>
    <app-statuses />
  </mat-tab>
  <mat-tab>
    <ng-template matTabLabel>
      <span i18n>Edit questionnaires</span>
    </ng-template>
    <app-status-questionnaire-edit />
  </mat-tab>
</mat-tab-group>
